import React from 'react'
import PhotoManager from '../Studio/PhotoAnalytics'
import PhotoAnalytics from '../Studio/PhotoAnalytics'

function Analytics() {
  return (
    <div className='w-full'><PhotoAnalytics /></div>
  )
}

export default Analytics